import CHILE_OFFER_FLOW_STEP_IDS from '../../../../../constants/factoring/chile-offer-flow-step-ids';
import ExternalCessionInstructionsStep from '../../steps/ExternalCessionInstructionsStep';

export default function buildExternalCessionInstructionsConfiguration({
  requireBankAccount,
}) {
  return {
    id: CHILE_OFFER_FLOW_STEP_IDS.EXTERNAL_CESSION_INSTRUCTIONS,
    title: 'Ceder desde mi facturador',
    tooltipTitle:
      'Consulta el centro de ayuda para aprender a ceder desde tu facturador. Para más información y manuales, contacta a tu ejecutivo/a',
    component: ExternalCessionInstructionsStep,
    props: {
      requireBankAccount,
    },
  };
}
